import { ArrowRight, Monitor } from 'lucide-react'
import { Link } from 'react-router-dom'
import type { Stats } from './index'
import { useFadeIn } from './useFadeIn'

export default function LandingCTA({ stats, loading }: { stats: Stats; loading: boolean }) {
  const fadeRef = useFadeIn<HTMLElement>()
  return (
    <section className="lp-cta-section" ref={fadeRef}>
      <div className="lp-cta-glow" />
      <div className="lp-wrap lp-cta-inner">
        <h2 className="lp-cta-title">Ready to inject intelligence?</h2>
        <p className="lp-cta-sub">Join {loading ? '...' : `${stats.total_users}+`} users already running AI agents on RunAI OS.</p>
        <div className="lp-cta-btns">
          <Link to="/register" className="lp-btn-primary">Get started free <ArrowRight size={14} /></Link>
          <Link to="/dashboard" className="lp-btn-ghost"><Monitor size={13} /> Open RunAI OS</Link>
        </div>
      </div>
    </section>
  )
}
